<template>
	<div class="mb-4">
		<v-row>
			<v-col cols="6" class="s-col-form">
				<!-- -->
				<v-card dense outlined  :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar label="1.- Información Recepción" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Peso Guía" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.RcfWeightGuide | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<v-label>
									{{ "-" }}
								</v-label>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Peso Neto" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.WbbNetWeight | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<v-label>
									{{ "-" }}
								</v-label>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4 :style="colorText">
									{{ "Diferencia " + textCondition + typeCaseWeight }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.infRefDifference | numberDefaultKg }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 :style="colorText">
									{{ lotReception.infRefDifferencePercentage | numberDefault }} %
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="6" class="s-col-form">
				<!-- -->
				<v-card dense outlined v-if="typeCaseWeight == 1 || (typeCaseWeight == 0)"  :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar label="2.- Tolerancia Peso Neto - Peso Guía %" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<!---->
						<v-row >
							<v-col class="s-col-form">
								<h4>
									{{ "Tolerancia aceptada" + typeCaseWeight }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<s-text 
									v-model="AcceptedToleranceInput" 
									decimal
									:max="100"
								/>
								 
								<!-- :readonly="lotReception.RcfStatusSap == 2" -->
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.tolWeiNetGuiToleranceAcceptedCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ tolWeiNetGuiText | numberDefault }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								
								<h4 :style="colorText">
									{{ lotReception.tolWeiNetGuiDiferenceNoAcceptedPercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<v-row v-if="true">
			<v-col cols="12" class="s-col-form">
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar :label="textcase3 + ' Descuentos a favor'" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "KG Total descarte (selección)" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisFavKgTotalDiscartPercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisFavKgTotalDiscartCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "kG a favor" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 style="color:#049967">
									{{ lotReception.DisFavKgFavorPercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisFavKgFavorCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "KG descarte Actualizado (descontar)" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisFavKgDiscartUpdatePercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.DisFavKgDiscartUpdateCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="6" class="s-col-form">
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar :label="textcase4 + ' Información Selección'" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Peso Actualizado" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.infSelWeightUpdate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Peso Lavado" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.infSelWeightWash | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>

						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Peso Descarte a favor" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.infSelDiscartFavor | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="6" class="s-col-form" v-if="typeCaseWeight == 0 || typeCaseWeight == 1 || typeCaseWeight == 2 || typeCaseWeight == 3 || typeCaseWeight == 4">
				<!--  -->
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar :label="textcase5 + ' Tolerancia Descarte Seleccion %'" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Tolerancia aceptada" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<s-text 
									v-model="AcceptedToleranceInputDiscart" 
									decimal
									
								/>
								<!-- :readonly="lotReception.RcfStatusSap == 2" -->
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.tolWeiDisSelToleranceAcceptedCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Descarte no aceptada" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 :style="colorText">
									{{ lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate | numberDefaultKg }}
								</h4>
								<v-checkbox
									v-model="lotReception.RfsDiscardNotAceppted"
									:label="labelCheckBox2"
									 @change="onCheckboxChange2"
								></v-checkbox>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
<!-- typeCaseWeight == 4 -->
			<v-col cols="6" class="s-col-form" v-if="false">
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar label="A favor" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "KG a favor" }}
								</h4>
							</v-col>
							
							<v-col class="s-col-form">
								<h4 :style="colorText">
									{{ lotReception.afavKgafavorPercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.afavKgafavorCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Descarte Aceptable" }}
								</h4>
							</v-col>
							
							<v-col class="s-col-form">
								<h4 :style="colorText">
									 
									<s-text 
										v-model.number="afavKgafavorPercentageInput"
										decimal
										:disabled="AfavKgafavorPercentageInput == 3 || AfavKgafavorPercentageInput == 4"
										:value="0"
									/>
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.afavKgafavorCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form">
								<h4>
									{{ "Descarte no aceptada" }}
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4 :style="colorText">
									{{ lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage | numberDefault }} %
								</h4>
							</v-col>
							<v-col class="s-col-form">
								<h4>
									{{ lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate | numberDefaultKg }}
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<!-- v-if="typeCaseWeight == 3 || typeCaseWeight == 4" -->
		<v-row class="mb-5">
			<v-col cols="6" class="s-col-form">
                <br>
                <v-row >
                    <v-col cols="12" class="s-col-form">
                        <v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
                            <s-toolbar :label="textcase6 + ' Descuentos totales'" color="#E0F7F2"></s-toolbar>
                            <v-card-text>
                                <v-row>
                                    <v-col class="s-col-form">
                                        <h4>
                                            {{ "Tolerancia no aceptada + Descarte no aceptada" }}
                                        </h4>
                                    </v-col>
                                    <v-col class="s-col-form">
                                        <h4>
                                            {{ lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted | numberDefaultKg }}
                                        </h4>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="s-col-form">
                                        <h4>
                                            {{ "Peso a pagar" }}
                                        </h4>
                                    </v-col>
                                    <v-col class="s-col-form">
                                        <h4>
                                            {{ lotReception.DisTotWeightPay | numberDefaultKg }}
                                        </h4>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                
                
			</v-col>
			<v-col cols="6" class="s-col-form">
				<v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					<s-toolbar :label="textcase7 + ' Distribución Almacenes'" color="#E0F7F2"></s-toolbar>
					<v-card-text>
						<v-row>
							<v-col class="s-col-form" cols="5"> 
								<h4>
									{{ "Peso Final aceptable" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<p class="font-weight-black text-end">
									<!-- {{ lotReception.RfsWeigth | numberDefaultKg }} -->
									{{ finalweightacceptable | numberDefaultKg }}
								</p>
							</v-col>
							<v-col class="s-col-form">
								<h4 class="success--text font-weight-black">
									{{ "Alm. 02" }} <span class="red--text font-weight-black">
														{{ this.lotReception.TypeEntryMerchandise == 3 ? " ( PAGO DIRECTO )" : "" }}
													</span>
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="5">
								<h4>
									{{ "Merma aceptable" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<p class="font-weight-black text-end">
									{{ lotReception.RfsWeightDiscart | numberDefaultKg }}
								</p>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<h4 class="red--text font-weight-black">
									{{ "Alm. 20" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<s-text 
									v-model="AcceptedDiscartMaq" 
									decimal
									:max="100"									
								/>							
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="5">
								<h4>
									{{ "Merma aceptable Maquila" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<p class="font-weight-black text-end">
									{{ lotReception.RfsWeightDiscartMaq | numberDefaultKg }}
								</p>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<h4 class="warning--text font-weight-black">
									{{ "Alm. 33" }}
								</h4>
								<!-- <h4 class="info--text font-weight-black">
									{{ "Merma Aceptable Maquila " + lotReception.PorceDiscartoMaq + "%" }} 
								</h4> -->
							</v-col>
							<v-col class="s-col-form" cols="3">
								<s-select-definition
									v-model="lotReception.TypeSupplierMaq"
									:def="1689"
									label="Tipo Proveedor Maq."
									clearable
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="5">
								<h4>
									{{ "Merma Excedente Maquila" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<p class="font-weight-black text-end">
									{{ lotReception.RfsWeightDiscardNotAcepptedMaq | numberDefaultKg }}
								</p>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<h4 class="warning--text font-weight-black">
									{{ "Alm. 33" }}
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form"  cols="5">
								<h4>
									{{ "Peso de bolillo" }}
								</h4>
							</v-col>
							<v-col class="s-col-form"  cols="2">
								<p class="font-weight-black text-end">
									{{ lotReception.RfsWeightBolilloc | numberDefaultKg }}
								</p>
							</v-col>
							<v-col class="s-col-form"  cols="2">
								<h4 class="info--text font-weight-black">
									{{ "Bolillo " + lotReception.PorceBolillo + "%" }} 
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<s-text 
									v-model="AcceptedBolilloMaq" 
									decimal
									:max="100"
									
								/>							
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="5">
								<h4>
									{{ "Peso de bolillo Maquila" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<p class="font-weight-black text-end">
									{{ lotReception.RfsWeightBolilloMaq | numberDefaultKg }}
								</p>
							</v-col>
							<v-col class="s-col-form">
								<h4 class="warning--text font-weight-black">
									{{ "Alm. 33" }}
								</h4>
								<!-- <h4 class="info--text font-weight-black">
									{{ "Bolillo Maquila " + lotReception.PorceBolilloMaq + "%" }} 
								</h4> -->
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="5">
								<h4>
									{{ "Peso de Devolucion" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<p class="font-weight-black text-end">
									{{ lotReception.RfsWeightDevolution | numberDefaultKg }}
								</p>
							</v-col>
							<v-col class="s-col-form">
								<h4 class="info--text font-weight-black">
									{{ "Devolucion" }} 
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="5">
								<h4>
									{{ "Peso de Devolucion por Pagar" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<p class="font-weight-black text-end">
									<!-- {{ lotReception.RfsWeightDevolutionByPay | numberDefaultKg }} -->
									{{ calculateTotalKgNoAceptable() | numberDefaultKg }}
								</p>
							</v-col>
							<v-col class="s-col-form">
								<h4 class="info--text font-weight-black">
									{{ "Devolucion por Pagar" }} 
									<v-checkbox
									v-model="lotReception.RfsDevolutionByPay"
									:label="labelCheckBox"
									 @change="onCheckboxChange"
								></v-checkbox>
								</h4>
								
							</v-col>
							
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="5">
								<h4>
									{{ "Peso a Favor" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<p class="font-weight-black text-end">
									{{ lotReception.RfsWeigthNotSap | numberDefaultKg }}
								</p>
							</v-col>
							<v-col class="s-col-form">
								<h4 class="info--text font-weight-black">
									{{ "No SAP" }} 
								</h4>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="s-col-form" cols="5">
								<h4 class="grey--text font-weight-black">
									{{ "Total SAP" }}
								</h4>
							</v-col>
							<v-col class="s-col-form" cols="2">
								<p class="grey--text font-weight-black text-end">
									{{ lotReception.TotalSap | numberDefaultKg }}
								</p>
							</v-col>
							<v-col class="s-col-form">
								<h4 class="grey--text font-weight-black">
									{{ "" }} 
								</h4>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
            
		</v-row>
		<v-row>
            <v-col cols="12" class="s-col-form">
                <v-card dense outlined :disabled="lotReception.RcfStatusSap == 2">
					
                    <s-toolbar label=" CALIBRES" color="#E0F7F2" :remove="removedCaliber" @removed="removeCalibers()" >

						<!-- <template #actions>
							<v-btn
							small
							color="error"
							@click="eliminarCalibres"
							class="ml-auto"
							>
							Eliminar registro de calibres
							</v-btn>
						</template> -->
					</s-toolbar>
					
                    <v-card-text cols="12" >
                        <v-row v-if="itemsCaliber.length==0">
                            <v-col class="s-col-form">
                                <h4>
                                    {{ "No hay Categorias de Pagos para la fecha actual" }}
                                </h4>
                            </v-col>                                   
                        </v-row>
                        
                        <v-row v-if="itemsCaliber.length>0">
                                    <!-- <v-col v-for="item in Object.keys(newGroups)" >
                                        <h4>{{ item }}</h4>
                                        <v-divider></v-divider> -->
                            <v-col class="pt-5 pr-0">
                                <!-- <v-row v-for="d in  Object.keys(newGroups[item]) " > -->
								<v-row v-for="item in Object.keys(newGroups)" :key="item" >
                                    <v-col cols="12" lg="8"
                                    class="pb-0 pt-1 pr-0 pl-0">
									<v-chip 
										small 
										:color = getColor(newGroups[item])
										> {{ item }}</v-chip>
								<!-- <v-chip v-if="viewPrices"
									small >
									{{ getPrice(newGroups[item][d]) }}
								</v-chip> -->
                                 
                                    <v-row v-for="(j, i) in newGroups[item]"  :key="i">									
                                        <v-col cols="2" lg="2" md="2">                                                   
                                            <s-text :label="j.TypeCaliberName"
                                                decimal
                                                :value="j.RfcQuantityKg == null ? 0.00 : j.RfcQuantityKg.toFixed(2)"
                                                :min="0"
                                                readonly
										
											></s-text>
                                            </v-col>
										<v-col cols="2" lg="2" md="2">                                                   
											<s-text :label="'Porcentaje'"
												decimal
												:value="j.RfcPercentage == null ? 0.00 : j.RfcPercentage"
												:min="0"
												readonly
												:suffix = "'%'"	
												disabled														
												></s-text>
											</v-col>
									    <!-- Porcentaje Aceptable -->
										<v-col cols="2" lg="2" md="2">
											<s-text
											label="% Aceptable"
											decimal										
											v-model="acceptablePercentages[j.DctgID]"											
											:readonly="j.RfcPercentage == 0"
											suffix="%"
											@input="updateNoAceptable(j)"
											/>
										</v-col>
										<v-col cols="2" lg="2" md="2">
											<s-text
											label="Aceptable en Kg."
											decimal
											v-model="j.RfcQuantityAcceptableKg"
											:value="j.RfcQuantityAcceptableKg == null ? 0.00 : j.RfcQuantityAcceptableKg"
											readonly
											suffix="Kg."
											disabled
											/>
										</v-col>

										<!-- Porcentaje No Aceptable (calculado) -->
										<v-col cols="2" lg="2" md="2">
											<s-text
											label="% No Aceptable"
											decimal
											:value="getUnacceptablePercentage(j)"
											readonly
											suffix="%"
											disabled
											/>
										</v-col>
										<!-- No Aceptable en Kg(calculado) -->
										<v-col cols="2" lg="2" md="2">
											<s-text
											label="No Aceptable en Kg."
											decimal
											v-model="j.RfcQuantityDevolutionByPayKg"
											:value="getUnacceptableKg(j)"
											readonly
											suffix="Kg."
											disabled
											/>
										</v-col>
                                    </v-row>
                                  
                                    </v-col>
                                </v-row>
                            </v-col>
                                    <!-- </v-col> -->
                        </v-row>
                    </v-card-text>
				
                </v-card>
            </v-col>
        </v-row>
	</div>
</template>

<script>
import _sReceptionFrozenService from '@/services/FrozenProduction/ReceptionFrozenService.js';
export default {
	props: {
		lotReception: {}
	},
	data() {
		return {
			// lotReception: {},
			AcceptedToleranceInput: 0,
			AcceptedToleranceInputDiscart: 0,
			afavKgafavorPercentageInput:0,
			AcceptedBolilloMaq : 0,
			AcceptedDiscartMaq : 0,
			RfsWeightDiscartLocal: 0,
			RfsWeightBolillocLocal:0,
			typeCaseWeight: 0,
			colorText: '',
			tolWeiNetGuiText: '',
			textcase3: "3.-",
			textcase4: "4.-",
			textcase5: "5.-",
			textcase6: "6.-",
			textcase7: "7.-",
            textcase8: "8.-",
			textCondition: "en Contra",
            newGroups:[],
			listItemsCalibers: [],
			itemsCaliber: [],
			loadPrice: [],
			labelCheckBox:"No",
			labelCheckBox2:"No",
			checkboxByPay: 0,
			porcentageDecimal: 0,
			acceptablePercentages: {}, // clave: índice o ID, valor: aceptable
			RfsWeigthLocal : 1,
			removedCaliber:false,
		}
	},
	// filters: {
	// 	numberDefaultKg: (value) => {
	// 		if( value == -Infinity ) return 0; 
	// 		if( value == Infinity ) return 0; 

	// 		if( isNaN(value) ) return 0; 
	// 		if( value == undefined ) return 0; 
	// 		// if( value < 0 ) return 0; 

	// 		console.log("valor tuberia", value)
	// 		return value;
	// 	}
	// },
	watch: {
		AcceptedToleranceInput() {
			this.getCalcule();

		},

		AcceptedToleranceInputDiscart() {
			this.getCalcule();
		},

		afavKgafavorPercentageInput(){
			this.getCalcule();
		},
		'lotReception.RfsDevolutionByPay'(){
			this.labelCheckBox= this.lotReception.RfsDevolutionByPay ? "Si" : "No";
		},
		AcceptedBolilloMaq(){
			this.getCaluleBolilloMaq();
		},
		//  AcceptedBolilloMaq(newVal, oldVal) {
		// 	console.log("AcceptedBolilloMaq CAMBIÓ");
		// 	console.log("ANTES:", oldVal);
		// 	console.log("AHORA :", newVal);
		// 	// console.trace();
		// },
		AcceptedDiscartMaq(){
			this.getCaluleDiscartMaq();
		},
		'lotReception.RfsDiscardNotAceppted'(){
			this.labelCheckBox2 = this.lotReception.RfsDiscardNotAceppted ? "Si" : "No";
			console.log("Prueba");
			this.calculateDiscartNotAcepptedMaq();
		}
	},
	methods: {
		removeCalibers(){
			this.itemsCaliber.map((i) => {
				i.SecStatus=0
			});
			this.$fun.alert("¿Está seguro de elimar los calibres del registro?", "question").then((resp) => {
				if (resp.value) {		
				_sReceptionFrozenService.caliberSapUpdate(this.itemsCaliber, this.$fun.getUserID()).then(r => { 
					if(r.status == 200){
						this.$fun.alert("Calibers removidos", "success");
						this.loadItemsCaliber();
					}
				});
				}
			});
			
		},

		onCheckboxChange(){
			this.$emit("DevolutionByPay", this.lotReception.RfsDevolutionByPay);
		},
		onCheckboxChange2(){
			this.$emit("DiscardNotAceppted", this.lotReception.RfsDiscardNotAceppted);
		},

		calculateDiscartNotAcepptedMaq(){
			console.log("this.lotReception.RfsDiscardNotAceppted",this.lotReception.RfsDiscardNotAceppted);
			if(this.lotReception.RfsDiscardNotAceppted){
				this.lotReception.RfsWeightDiscardNotAcepptedMaq = this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate;
				this.lotReception.TotalSap = parseFloat(this.lotReception.RfsWeigth) + parseFloat(this.lotReception.RfsWeightDiscart) + parseFloat(this.RfsWeightBolillocLocal)+ parseFloat(this.lotReception.RfsWeightDiscartMaq) + parseFloat(this.lotReception.RfsWeightDiscardNotAcepptedMaq);
			}else{
				this.lotReception.RfsWeightDiscardNotAcepptedMaq = 0;
				this.lotReception.TotalSap = parseFloat(this.lotReception.RfsWeigth) + parseFloat(this.lotReception.RfsWeightDiscart) + parseFloat(this.RfsWeightBolillocLocal)+ parseFloat(this.lotReception.RfsWeightDiscartMaq);
			}
			console.log("RfsWeightDiscardNotAcepptedMaq",this.lotReception.RfsWeightDiscardNotAcepptedMaq);
		},

		calculateTotalKgNoAceptable() {
			let total = 0;
			for (const groupKey of Object.keys(this.newGroups)) {
				for (const item of this.newGroups[groupKey]) {
					const value = parseFloat(this.getUnacceptableKg(item));
					total += isNaN(value) ? 0 : value;
				}
			}

			//console.log("Total", total);

			// if (total > 0) this.lotReception.RfsWeigth = (this.lotReception.TotalSap.toFixed(2) - total.toFixed(2));
			if (total > 0) {
				//console.log("Total2222", total);

				this.lotReception.RfsWeigth = (this.RfsWeigthLocal - total).toFixed(2);
				this.lotReception.RfsWeightDevolutionByPay = total.toFixed(2);

				//console.log("Total3333", this.lotReception.RfsWeigth);

			}


			return total.toFixed(2);
		},

		getUnacceptableKg(j) {
			// const totalPct = parseFloat(item.RfcPercentage || 0); // Ej. 42.17
			// const noAceptablePct = parseFloat(this.getUnacceptablePercentage(item) || 0); // Ej. 42.17
			// const quantity = parseFloat(item.RfcQuantityKg || 0); // Ej. 3.21 kg

			// if (totalPct === 0) return "0.00"; // Evita división por cero

			// const result = (noAceptablePct * quantity) / totalPct;
			// item.RfcQuantityDevolutionByPayKg = result.toFixed(2);
			// item.RfcQuantityAcceptableKg = (quantity - result).toFixed(2);
			// return result.toFixed(2);

			// const id = item.DctgID;
			// const aceptablePct = parseFloat(this.acceptablePercentages[id] || 0); // Porcentaje aceptable definido por el usuario
			// const quantity = parseFloat(item.RfcQuantityKg || 0); // Peso actual del ítem
			// const netWeight = parseFloat(this.lotReception.WbbNetWeight || 0); // Peso neto total del lote

			// if (netWeight === 0) return "0.00"; // Evita división por cero

			// // Calcula los KG aceptables según el % del lote
			// const acceptableKg = (netWeight * aceptablePct) / 100;

			// // KG no aceptables = lo reportado - lo aceptable
			// let notAcceptableKg = quantity - acceptableKg;

			// if (notAcceptableKg < 0) notAcceptableKg = 0;

			// item.RfcQuantityAcceptableKg = acceptableKg.toFixed(2);
			// item.RfcQuantityDevolutionByPayKg = notAcceptableKg.toFixed(2);

			// return notAcceptableKg.toFixed(2);

			return j.RfcQuantityDevolutionByPayKg != null
			? j.RfcQuantityDevolutionByPayKg.toFixed(2)
			: '0.00';

		},
		updateNoAceptable(j) {
			// const id = item.DctgID;
			// let aceptable = parseFloat(this.acceptablePercentages[id] || 0);
			// let total = parseFloat(item.RfcPercentage || 0);

			// console.log("aceptable", aceptable);

			// // Validamos que no se pase del total
			// if (aceptable > total) {
			// this.acceptablePercentages[id] = total;
			// }

			const totalKg = (parseFloat(this.lotReception.WbbNetWeight) - parseFloat(this.lotReception.RfsWeightDevolution));
			let userPercentage = parseFloat(this.acceptablePercentages[j.DctgID]) || 0;

			// 1. Calcular el porcentaje original desde los kg
			const originalPercentage = (j.RfcQuantityKg * 100) / totalKg;

			// ✅ Validar que el usuario no supere el % máximo permitido
			if (userPercentage > originalPercentage) {
				this.acceptablePercentages[j.DctgID] = originalPercentage.toFixed(5);
				userPercentage = originalPercentage;
			}

			// 2. Calcular los kg aceptables desde el % ingresado
			const acceptableKg = parseFloat(((totalKg * userPercentage) / 100).toFixed(2));

			// 3. Calcular los kg no aceptables como diferencia
			const noAcceptableKg = parseFloat((j.RfcQuantityKg - acceptableKg).toFixed(2));

			// 4. Calcular el % no aceptable como diferencia
			const noAcceptablePercent = parseFloat((originalPercentage - userPercentage).toFixed(2));

			// 5. Asignar los valores
			j.RfcQuantityAcceptableKg = acceptableKg;
			j.RfcQuantityDevolutionByPayKg = noAcceptableKg;
			j._UnacceptablePercentage = noAcceptablePercent; // Usado por getUnacceptablePercentage si querés
  
		},
		getUnacceptablePercentage(j) {
			// const id = item.DctgID;
			// const total = parseFloat(item.RfcPercentage || 0);

			// // Si aún no existe el valor en el mapa, lo inicializas igual al total
			// if (!(id in this.acceptablePercentages)) {
			// 	this.$set(this.acceptablePercentages, id, total);
			// 	return 0.00;
			// }

			// const aceptable = parseFloat(this.acceptablePercentages[id] || 0);
			// const noAceptable = total - aceptable;

			// return noAceptable <= 0 ? 0.00 : noAceptable.toFixed(2);

			return j._UnacceptablePercentage != null
			? j._UnacceptablePercentage.toFixed(2)
			: '0.00';
		},	
        loadItemsCaliber(){
			console.log("RcfID",this.lotReception);
			
            _sReceptionFrozenService
				.GetCaliber(
					{ RcfID: this.lotReception.RcfID, TypeCultive: this.lotReception.TypeCultive },
						this.$fun.getUserID(),
					)
					.then(r => {
						var dataCaliber = r.data;
						//console.log("Itemmmsss",r);
						this.itemsCaliber = dataCaliber;
						
						if(this.itemsCaliber.length == 0)return;
							
						this.travelCaliber(dataCaliber);
                    });
        },

        travelCaliber(itemsCaliber){
            //console.log("items caliberrr",itemsCaliber);
            // var sum  = 0;

            // 	// for (let prop in itemsCaliber) {
			// 		//console.log("Descripci111111111111111",prop);
            //         this.itemsCaliber.map((i) => {

            //             i.RcfID = this.lotReception.RcfID;
            //             i.SecStatus = 1
			// 			i.RfsID= this.lotReception.RfsID || 0;
            //             i.UsrCreateID = this.$fun.getUserID();
			// 			i.UsrUpdateID = i.RfcID ? this.$fun.getUserID(): 0;
            //             if(i.RfcQuantityKg == ''){
            //                 i.RfcQuantityKg = 0
            //             }
            //             sum += parseFloat(i.RfcQuantityKg == null ? 0 : i.RfcQuantityKg)
			// 			const total = this.lotReception.WbbNetWeight || 0;
			// 			if (total > 0 && i.RfcQuantityKg > 0 ) {
			// 				const percent = (i.RfcQuantityKg * 100) / total;
			// 				i.RfcPercentage = percent.toFixed(2);
			// 			} else {
			// 				i.RfcPercentage = 0;
			// 			}
			// 			const id = i.DctgID;
			// 			if(total > 0 && i.RfcQuantityAcceptableKg > 0){
			// 				const percentAcceptable = ((i.RfcQuantityAcceptableKg * 100) / total).toFixed(2);
			// 				if (!(id in this.acceptablePercentages)) {
			// 					this.$set(this.acceptablePercentages, id, percentAcceptable);
			// 					return 0.00;
			// 				}
							
			// 			}
			// 			// if(i.RfcQuantityDevolutionByPayKg > 0){
			// 			// 	const percentDevolutionByPay = ((i.RfcQuantityDevolutionByPayKg * 100) / total).toFixed(2);
							
			// 			// }
            //         });
            //         let description = {};
            //         description = _.groupBy(this.itemsCaliber, "CtgDescription");
			// 		//console.log("Descripci111111111111111",prop);
			// 		//console.log("Descripcionnnnn",description);
					
			// 		for (const atributo in description) {
			// 			description[atributo].forEach(element => {
			// 				//console.log("Caliberrr11232323",element);
			// 				this.listItemsCalibers.push(element);
			// 			});
			// 		}
					
            //         this.newGroups = description;
            //        //console.log("nuevo Group",this.newGroups);
			// 	   this.$emit("itemsCalibers", this.listItemsCalibers);
            //     // }	
			
			this.listItemsCalibers = [];
			let sum = 0;
			// const total = this.lotReception.WbbNetWeight || 0;
			const total = (parseFloat(this.lotReception.WbbNetWeight) - parseFloat(this.lotReception.RfsWeightDevolution));

			this.removedCaliber = this.itemsCaliber.some((i) => i.RfcID > 0);

			this.itemsCaliber.map((i) => {
				i.RcfID = this.lotReception.RcfID;
				i.SecStatus = 1;
				i.RfsID = this.lotReception.RfsID || 0;
				i.UsrCreateID = this.$fun.getUserID();
				i.UsrUpdateID = i.RfcID ? this.$fun.getUserID() : 0;

				// Validar cantidad
				i.RfcQuantityKg = parseFloat(i.RfcQuantityKg) || 0;

				sum += parseFloat(i.RfcQuantityKg == null ? 0 : i.RfcQuantityKg);

				

				// Calcular % original
				if (total > 0 && i.RfcQuantityKg > 0) {
					const percent = (i.RfcQuantityKg * 100) / total;
					i.RfcPercentage = parseFloat(percent.toFixed(5));
				} else {
					i.RfcPercentage = 0.00;
				}

				const id = i.DctgID;

				// Caso cuando ya fue registrado (RfcID > 0)
				if (total > 0 && i.RfcID > 0) {
					if (i.RfcQuantityAcceptableKg > 0) {
						// Recalcular % aceptable desde los kg aceptables ya guardados
						const percentAcceptable = (i.RfcQuantityAcceptableKg * 100) / total;
						this.$set(this.acceptablePercentages, id, parseFloat(percentAcceptable.toFixed(5)));
					}

					// Calcular % no aceptable como diferencia
					const percentNoAcceptable = i.RfcPercentage - (this.acceptablePercentages[id] || 0);
					i._UnacceptablePercentage = parseFloat(percentNoAcceptable.toFixed(5));

					// Calcular kg no aceptables como diferencia
					i.RfcQuantityDevolutionByPayKg = parseFloat((i.RfcQuantityKg - i.RfcQuantityAcceptableKg).toFixed(5));
				}

				// Caso nuevo (no registrado)
				if (!i.RfcID || i.RfcID === 0) {
				// Aceptable = 100% del porcentaje original					
					this.$set(this.acceptablePercentages, id, i.RfcPercentage);
					i.RfcQuantityAcceptableKg = i.RfcQuantityKg != null ? parseFloat(i.RfcQuantityKg.toFixed(2)) : 0.00;
					i.RfcQuantityDevolutionByPayKg = 0.00;
					i._UnacceptablePercentage = 0.00;
				}
			});

			// Agrupar por descripción
			const description = _.groupBy(this.itemsCaliber, "CtgDescription");

			for (const atributo in description) {
				description[atributo].forEach((element) => {
				this.listItemsCalibers.push(element);
				});
			}

			this.newGroups = description;
			this.$emit("itemsCalibers", this.listItemsCalibers);
        },
        getPrice(j) {
			if(this.loadPrice.some((x) => x.CtgID === j[0].CtgID))
				return this.loadPrice.find((x) => x.CtgID === j[0].CtgID).CfpAmount; 
			else
				return 0;
		},
        getColor(j) {
			return this.loadPrice.some((x) => x.CtgID === j[0].CtgID) ? 'success' : '#b7b7b7';
		},

		getCalcule() {
			this.getCalculeInner();
			this.calculateDiscartNotAcepptedMaq();
			this.getCaluleDiscartMaq();
			this.getCaluleBolilloMaq();
		},
		getCalculeInner() {
			this.typeCaseWeight = 1;
			this.lotReception.RfsWeigthNotSap = 0;
			this.lotReception.RcfWeightCondition = 0;

			// this.lotReception.WbbNetWeight = parseFloat(this.lotReception.WbbNetWeight).toFixed(4)
			// this.lotReception.RcfWeightGuide = parseFloat(this.lotReception.RcfWeightGuide).toFixed(4)

			this.lotReception.infRefDifference = (this.lotReception.WbbNetWeight - this.lotReception.RcfWeightGuide).toFixed(2);
			this.lotReception.infRefDifferencePercentage = this.lotReception.RcfWeightGuide > 0
				? ((this.lotReception.infRefDifference / this.lotReception.RcfWeightGuide) * 100).toFixed(6)//0910
				: 0


				console.log({ 
					RcfWeightGuide: this.lotReception.RcfWeightGuide,
					WbbNetWeight: this.lotReception.WbbNetWeight,
					infRefDifference: this.lotReception.infRefDifference ,
					discart: this.lotReception.discart 
				})


			if (this.lotReception.RcfWeightGuide >= this.lotReception.WbbNetWeight) {
				//console.log("getCalculeCase1y2", "getCalculeCase1y2")
				this.typeCaseWeight = 1;
				this.getCalculeCase1y2();

				return;
			}

			this.textcase3 = "2.-";
			this.textcase4 = "3.-";
			this.textcase5 = "4.-";
			this.textcase6 = "5.-";
			this.textcase7 = "6.-";
			this.textCondition = "a Favor";
			this.lotReception.RcfWeightCondition = 1
			console.log("infRefDifference", this.lotReception.infRefDifference)
			console.log("lotReception.discart", this.lotReception.discart)

			
			 
			if (this.lotReception.RcfWeightGuide < this.lotReception.WbbNetWeight && 
				parseFloat(this.lotReception.infRefDifference) > parseFloat(this.lotReception.discart)) {
				console.log("getCalculeCase4", "getCalculeCase4")

				this.typeCaseWeight = 4;
				this.getCalculeCase4();
				return;
			}
			if (this.lotReception.RcfWeightGuide < this.lotReception.WbbNetWeight && 
				parseFloat(this.lotReception.infRefDifference) <= parseFloat(this.lotReception.discart)) {
				console.log("getCalculeCase3", "getCalculeCase3")

				this.typeCaseWeight = 3;
				this.getCalculeCase3();
			}


			// this.lotReception.AcceptedToleranceInput = this.AcceptedToleranceInput;
			// this.lotReception.AcceptedToleranceInputDiscart = this.AcceptedToleranceInputDiscart;
		},

		getCalculeCase1y2() {
			//peso guía mayor al peso neto - diferencia de peso guia y neto mayor a 2% - descarte mayor a 3%
			this.typeCaseWeight = 1;
			this.colorText = 'color:red';
			this.tolWeiNetGuiText = 'Diferencia no aceptada'

			this.lotReception.infRefDifference = (this.lotReception.RcfWeightGuide - this.lotReception.WbbNetWeight).toFixed(6);
			this.lotReception.infRefDifferencePercentage = this.lotReception.RcfWeightGuide > 0
				? ((this.lotReception.infRefDifference / this.lotReception.RcfWeightGuide) * 100).toFixed(6)
				: 0

				//console.log("infRefDifferencePercentage", this.lotReception.infRefDifferencePercentage);
			this.lotReception.tolWeiNetGuiToleranceAcceptedPercentageInput = this.AcceptedToleranceInput;
			if (parseFloat(this.AcceptedToleranceInput) >= parseFloat(this.lotReception.infRefDifferencePercentage)) {
				this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate = this.lotReception.infRefDifference;
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedPercentage = 0.00;
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate = 0.00;

				 
			}
			if (parseFloat(this.AcceptedToleranceInput) < parseFloat(this.lotReception.infRefDifferencePercentage)) {
				this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate = ((this.lotReception.RcfWeightGuide -  this.lotReception.RfsWeightDevolution ) * (this.AcceptedToleranceInput / 100)).toFixed(2);
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedPercentage = (this.lotReception.infRefDifferencePercentage - this.AcceptedToleranceInput).toFixed(2);
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate = (this.lotReception.infRefDifference - this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate).toFixed(2);
				
				 
			}

			this.lotReception.infSelWeightUpdate = (this.lotReception.RcfWeightGuide - this.lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate).toFixed(2);
			this.lotReception.infSelWeightWash = (this.lotReception.WbbNetWeight - this.lotReception.discart - this.lotReception.RfsWeightDevolution - this.lotReception.RfsWeightBolillo).toFixed(2);

			this.lotReception.tolWeiDisSelToleranceAcceptedPercentageInput = this.AcceptedToleranceInputDiscart;

			// console.log("this.AcceptedToleranceInputDiscart", this.AcceptedToleranceInputDiscart)
			// console.log("this.this.lotReception.discartPercentage", this.lotReception.discartPercentage)


			//let percenteadisc = (this.lotReception.discart / this.lotReception.RcfWeightGuide * 100).toFixed(2)//0910
			let percenteadisc = (this.lotReception.discart / (this.lotReception.RcfWeightGuide -  this.lotReception.RfsWeightDevolution) * 100).toFixed(2)//1206

			// if (parseFloat(this.AcceptedToleranceInputDiscart) >= parseFloat(this.lotReception.discartPercentage)) {
			if (parseFloat(this.AcceptedToleranceInputDiscart) >= parseFloat(percenteadisc)) {
				//samir
				console.log({ AcceptedToleranceInputDiscart: this.AcceptedToleranceInputDiscart })
				console.log({ discartPercentage: this.lotReception.discartPercentage })
				// console.log("1")
				
				//case1
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = this.lotReception.discart;////.DisFavKgDiscartUpdateCalculate
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = 0.00;
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = 0.00;


				this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = percenteadisc;//SAMIR
				//this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
			}
			if (parseFloat(this.AcceptedToleranceInputDiscart) < parseFloat(percenteadisc)) {
				//samir
				// console.log("2")
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculate =
				 ((this.lotReception.RcfWeightGuide - this.lotReception.RfsWeightDevolution) * (this.AcceptedToleranceInputDiscart / 100)).toFixed(2);//case1 0910 WbbNetWeight 
  
				// this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = (this.lotReception.discartPercentage - this.AcceptedToleranceInputDiscart).toFixed(4);
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = (percenteadisc - this.AcceptedToleranceInputDiscart).toFixed(6);

				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = (this.lotReception.discart - this.lotReception.tolWeiDisSelToleranceAcceptedCalculate).toFixed(4);

				this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage ?? 0;
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate ?? 0;

				this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
			}

			this.lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted = (parseFloat(this.lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate) + parseFloat(this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate)).toFixed(2);
			this.lotReception.DisTotWeightPay = (this.lotReception.RcfWeightGuide - this.lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted).toFixed(2) ;

			//DISTRIBUCION DE ALMACENES
			this.lotReception.RfsWeightDiscart = (parseFloat(this.lotReception.tolWeiDisSelToleranceAcceptedCalculate) + parseFloat(this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate)).toFixed(2);
			this.lotReception.RfsWeigth = (parseFloat(this.lotReception.DisTotWeightPay) - parseFloat(this.lotReception.RfsWeightDiscart) 
			- parseFloat(this.lotReception.RfsWeightBolillo) - parseFloat(this.lotReception.RfsWeightDevolution)).toFixed(2);
			
			//VALIDAR SI ES PAGOS DIRECTOS

			let amountProc = this.lotReception.RfsWeigth;
			let amountDisc = this.lotReception.RfsWeightDiscart;

			// console.log("CASO 1" + this.lotReception.TypeEntryMerchandise)
			if (this.lotReception.TypeEntryMerchandise == 3) {
				this.lotReception.RfsWeigth = amountDisc;
				this.lotReception.RfsWeightDiscart = amountProc;
			}
			this.lotReception.AcceptedToleranceInput = this.AcceptedToleranceInput;
			this.lotReception.AcceptedToleranceInputDiscart = this.AcceptedToleranceInputDiscart;

			this.lotReception.TotalSap = parseFloat(this.lotReception.RfsWeigth) + parseFloat(this.lotReception.RfsWeightDiscart) + parseFloat(this.lotReception.RfsWeightBolillo) + parseFloat(this.lotReception.RfsWeightDiscartMaq) + parseFloat(this.lotReception.RfsWeightDiscardNotAcepptedMaq);
			// console.log("this.lotReception.TotalSap" , this.lotReception.TotalSap)

			this.RfsWeightDiscartLocal = this.lotReception.RfsWeightDiscart;
			this.lotReception.PorceBolillo = 0;
			if (this.lotReception.RfsWeightBolillo > 0 && this.lotReception.WbbNetWeight) {
				
				this.lotReception.PorceBolillo = ((parseFloat(this.lotReception.RfsWeightBolillo)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2)
			}
			console.log("bolillo11111",this.lotReception.RfsWeightBolilloc);			
			this.lotReception.RfsWeightBolilloc = this.lotReception.RfsWeightBolillo;
			
			this.RfsWeightBolillocLocal = parseFloat(this.lotReception.RfsWeightBolilloc).toFixed(2);
			this.calculateDiscartNotAcepptedMaq();
		},

		getCalculeCase3() {
			//peso guía mayor al peso neto - diferencia de peso guia y neto menor a 2% - descarte menor a 3%
			this.typeCaseWeight = 3;
			this.colorText = 'color:green';
			this.tolWeiNetGuiText = 'KG a favor';

			this.lotReception.infRefDifference = (this.lotReception.WbbNetWeight - this.lotReception.RcfWeightGuide).toFixed(2);
			this.lotReception.infRefDifferencePercentage = this.lotReception.RcfWeightGuide > 0
				? ((this.lotReception.infRefDifference / (this.lotReception.RcfWeightGuide - this.lotReception.RfsWeightDevolution)) * 100).toFixed(2)
				: 0

			this.lotReception.tolWeiNetGuiToleranceAcceptedPercentageInput = this.AcceptedToleranceInput;
			if (parseFloat(this.AcceptedToleranceInput) >= parseFloat(this.lotReception.infRefDifferencePercentage)) {
				this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate = this.lotReception.infRefDifference;
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedPercentage = 0.00;
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate = 0.00;
			}
			if (parseFloat(this.AcceptedToleranceInput) < parseFloat(this.lotReception.infRefDifferencePercentage)) {
				this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate = (this.lotReception.RcfWeightGuide * (this.AcceptedToleranceInput / 100)).toFixed(2);
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedPercentage = (this.lotReception.infRefDifferencePercentage - this.AcceptedToleranceInput).toFixed(2);
				this.lotReception.tolWeiNetGuiDiferenceNoAcceptedCalculate = (this.lotReception.infRefDifference - this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate).toFixed(2);
			}

			// this.lotReception.DisFavKgTotalDiscartPercentage = (this.lotReception.discart / (this.lotReception.RcfWeightGuide - this.lotReception.RfsWeightDevolution) * 100).toFixed(2)
			this.lotReception.DisFavKgTotalDiscartPercentage = (this.lotReception.discart / this.lotReception.RcfWeightGuide * 100).toFixed(2)
			this.lotReception.DisFavKgTotalDiscartCalculate = this.lotReception.discart;
			this.lotReception.DisFavKgFavorPercentage = this.lotReception.infRefDifferencePercentage;
			this.lotReception.DisFavKgFavorCalculate = this.lotReception.infRefDifference;
			
			this.lotReception.DisFavKgDiscartUpdateCalculate = (this.lotReception.DisFavKgTotalDiscartCalculate - this.lotReception.DisFavKgFavorCalculate).toFixed(2);
			/* this.lotReception.DisFavKgDiscartUpdatePercentage = ((this.lotReception.DisFavKgDiscartUpdateCalculate / this.lotReception.RcfWeightGuide) * 100).toFixed(2); */
			this.lotReception.DisFavKgDiscartUpdatePercentage = 
			((this.lotReception.DisFavKgDiscartUpdateCalculate / (this.lotReception.RcfWeightGuide - this.lotReception.RfsWeightDevolution)) * 100).toFixed(2);//1610 WbbNetWeight

			console.log("DisFavKgDiscartUpdateCalculate" , this.lotReception.DisFavKgDiscartUpdateCalculate);


			this.lotReception.infSelWeightUpdate = (this.lotReception.RcfWeightGuide);
			//peso lavado
			this.lotReception.infSelWeightWash = (this.lotReception.WbbNetWeight - this.lotReception.discart - this.lotReception.RfsWeightDevolution - this.lotReception.RfsWeightBolillo);// 

			this.lotReception.tolWeiDisSelToleranceAcceptedPercentageInput = this.AcceptedToleranceInputDiscart;
			// if(this.AcceptedToleranceInputDiscart >= this.lotReception.discartPercentage) 
			// console.log({
			// 	"if": "antes de el if",
			// 	AcceptedToleranceInputDiscart: this.AcceptedToleranceInputDiscart,
			// 	DisFavKgDiscartUpdatePercentage: this.lotReception.DisFavKgDiscartUpdatePercentage,
			// })
			//case 3
			if (parseFloat(this.AcceptedToleranceInputDiscart) >= parseFloat(this.lotReception.DisFavKgDiscartUpdatePercentage)) {
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = this.lotReception.DisFavKgDiscartUpdateCalculate;//.discart;
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = 0.00;
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = 0.00;
				// console.log({ "if": 1 })

				this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.lotReception.DisFavKgDiscartUpdatePercentage;//SAMIR
				//this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
			}
			// if(this.AcceptedToleranceInputDiscart < this.lotReception.discartPercentage) 
			// RcfWeightGuide
			if (parseFloat(this.AcceptedToleranceInputDiscart) < parseFloat(this.lotReception.DisFavKgDiscartUpdatePercentage)) {
				//aceptable
			
				//this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = (this.lotReception.DisFavKgDiscartUpdatePercentage - this.AcceptedToleranceInputDiscart).toFixed(6);
				 this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = (((this.lotReception.DisFavKgDiscartUpdateCalculate / (this.lotReception.RcfWeightGuide - this.lotReception.RfsWeightDevolution)) * 100) - this.AcceptedToleranceInputDiscart).toFixed(6);
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = 
				(((this.lotReception.RcfWeightGuide - this.lotReception.RfsWeightDevolution) * this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage) / 100).toFixed(6);// 0910WbbNetWeight 

				console.log("this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate",this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate)
				
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = 
					((this.lotReception.RcfWeightGuide - this.lotReception.RfsWeightDevolution

					) * (this.AcceptedToleranceInputDiscart / 100)).toFixed(6);//case3 0910 WbbNetWeight



				// console.log(
				// 	{ 
				// 		"if": 2 ,
				// 		DisFavKgDiscartUpdatePercentage: this.lotReception.DisFavKgDiscartUpdatePercentage,
				// 		AcceptedToleranceInputDiscart:this.AcceptedToleranceInputDiscart
				// 	}
				// 	)

					// this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.lotReception.DisFavKgDiscartUpdatePercentage;//SAMIR
					this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
			}
			// console.log({ AcceptedToleranceInputDiscart: this.AcceptedToleranceInputDiscart })
			// console.log({ discartPercentage: this.lotReception.DisFavKgDiscartUpdatePercentage })
			// console.log({ tolWeiDisSelToleranceAcceptedCalculate: this.lotReception.tolWeiDisSelToleranceAcceptedCalculate, tern: "3" })

			this.lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted = (parseFloat(this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate)).toFixed(2);
			this.lotReception.DisTotWeightPay = (this.lotReception.RcfWeightGuide - this.lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted).toFixed(2);

			// console.log({
			// 	RcfWeightGuide: this.lotReception.RcfWeightGuide,
			// 	DisTotDifferenceNoAcceptedJoinDiscartNoAccepted: this.lotReception.DisTotDifferenceNoAcceptedJoinDiscartNoAccepted
			// })

			//this.lotReception.RfsWeigthNotSap = parseFloat(this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate).toFixed(2);
			//DISTRIBUCION DE ALAMCENES
			// this.lotReception.RfsWeigthNotSap = parseFloat(this.lotReception.infRefDifference).toFixed(2);
			this.lotReception.RfsWeightDiscart = (parseFloat(this.lotReception.tolWeiDisSelToleranceAcceptedCalculate) + parseFloat(0)).toFixed(2);
			//infSelWeightWash
			this.lotReception.RfsWeigth = (this.lotReception.DisTotWeightPay - this.lotReception.RfsWeightDiscart
			- this.lotReception.RfsWeightBolillo - this.lotReception.RfsWeightDevolution 
			// - this.lotReception.infRefDifference
			).toFixed(2);//cambie //--4

			console.log("Peso weigth", this.lotReception.RfsWeigth);
			
			//this.lotReception.RfsWeigth = (parseFloat(this.lotReception.infSelWeightWash) - parseFloat(0)).toFixed(2);//antes
			// console.log( "calcular DisTotWeightPay", this.lotReception.DisTotWeightPay )
			//console.log( "calcular RfsWeightDiscart", this.lotReception.RfsWeightDiscart )
			//console.log( "calcular discart", this.lotReception.discart )
			 
			//console.log( "calcular RfsWeightBolillo", this.lotReception.RfsWeightBolillo )
			//console.log( "calcular RfsWeightDevolution", this.lotReception.RfsWeightDevolution )
			
			//VALIDAR SI ES PAGOS DIRECTOS

			let amountProc = this.lotReception.RfsWeigth;
			let amountDisc = this.lotReception.RfsWeightDiscart;

			if (this.lotReception.TypeEntryMerchandise == 3) {
				this.lotReception.RfsWeigth = amountDisc;
				this.lotReception.RfsWeightDiscart = amountProc;
			}
			//console.log({ RfsWeightDiscart: this.lotReception.RfsWeightDiscart })
			//console.log({ RfsWeigth: this.lotReception.RfsWeigth })

			this.lotReception.AcceptedToleranceInput = this.AcceptedToleranceInput;
			this.lotReception.AcceptedToleranceInputDiscart = this.AcceptedToleranceInputDiscart;

			this.lotReception.TotalSap = parseFloat(this.lotReception.RfsWeigth) + parseFloat(this.lotReception.RfsWeightDiscart) + parseFloat(this.lotReception.RfsWeightBolillo)+ parseFloat(this.lotReception.RfsWeightDiscartMaq) + parseFloat(this.lotReception.RfsWeightDiscardNotAcepptedMaq);
			//console.log("this.lotReception.TotalSap" , this.lotReception.TotalSap)
			this.RfsWeightDiscartLocal = this.lotReception.RfsWeightDiscart;
			this.lotReception.PorceBolillo = 0;
			if (this.lotReception.RfsWeightBolillo > 0 && this.lotReception.WbbNetWeight) {
				
				this.lotReception.PorceBolillo = ((parseFloat(this.lotReception.RfsWeightBolillo)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2)
			}
			console.log("bolillo22222");			
			this.lotReception.RfsWeightBolilloc = this.lotReception.RfsWeightBolillo;
			
			this.RfsWeightBolillocLocal = parseFloat(this.lotReception.RfsWeightBolilloc).toFixed(2);
			this.calculateDiscartNotAcepptedMaq();
		},

		getCalculeCase4() {
			//peso guía mayor al peso neto 
			this.typeCaseWeight = 4;
			this.colorText = 'color:green';
			this.tolWeiNetGuiText = 'KG a favor';

			this.lotReception.infRefDifference = (this.lotReception.WbbNetWeight - this.lotReception.RcfWeightGuide).toFixed(2);
			this.lotReception.infRefDifferencePercentage = this.lotReception.RcfWeightGuide > 0
				? ((this.lotReception.infRefDifference / this.lotReception.RcfWeightGuide) * 100).toFixed(2) //0910 WbbNetWeight
				: 0;

			//samir

			this.lotReception.tolWeiDisSelToleranceAcceptedPercentageInput = this.AcceptedToleranceInputDiscart;
			// if(this.AcceptedToleranceInputDiscart >= this.lotReception.discartPercentage) 
			this.lotReception.DisFavKgDiscartUpdatePercentage = this.lotReception.DisFavKgDiscartUpdatePercentage ?? 0;

			// console.log({
			// 	"if": "antes de el if",
			// 	AcceptedToleranceInputDiscart: this.AcceptedToleranceInputDiscart,
			// 	DisFavKgDiscartUpdatePercentage: this.lotReception.DisFavKgDiscartUpdatePercentage,
			// })
			//case 4
			// DisFavKgDiscartUpdateCalculate
			// this.lotReception.DisFavKgTotalDiscartPercentage = this.lotReception.discartPercentage;
			this.lotReception.DisFavKgTotalDiscartPercentage = (this.lotReception.discart / this.lotReception.RcfWeightGuide * 100);//0910
			this.lotReception.DisFavKgTotalDiscartCalculate = this.lotReception.discart;
			this.lotReception.DisFavKgFavorPercentage = this.lotReception.infRefDifferencePercentage;
			this.lotReception.DisFavKgFavorCalculate = this.lotReception.infRefDifference;
			this.lotReception.DisFavKgDiscartUpdatePercentage = ((this.lotReception.DisFavKgFavorPercentage - this.lotReception.DisFavKgTotalDiscartPercentage)).toFixed(6);
			this.lotReception.DisFavKgDiscartUpdateCalculate = (this.lotReception.DisFavKgFavorCalculate - this.lotReception.DisFavKgTotalDiscartCalculate).toFixed(6);

			// console.log("total descarte", this.lotReception.DisFavKgDiscartUpdatePercentage)
			
			if ((parseFloat(this.AcceptedToleranceInputDiscart) >= parseFloat(this.lotReception.DisFavKgDiscartUpdatePercentage))) {
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = this.lotReception.DisFavKgDiscartUpdateCalculate;//.discart;
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = 0.00;
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = 0.00;
				 console.log({ "if": 1 })

				this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.lotReception.DisFavKgDiscartUpdatePercentage;//SAMIR
				//this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
			}
			// if(this.AcceptedToleranceInputDiscart < this.lotReception.discartPercentage) 
			if ((parseFloat(this.AcceptedToleranceInputDiscart) < parseFloat(this.lotReception.DisFavKgDiscartUpdatePercentage)) || this.lotReception.DisFavKgDiscartUpdatePercentage == 0) {
				//0910
				// this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = (this.lotReception.DisFavKgDiscartUpdateCalculate * this.AcceptedToleranceInputDiscart)
				// 							/this.lotReception.DisFavKgDiscartUpdatePercentage;

				//  console.log("dadsa culupu primero 1 ", this.lotReception.DisFavKgDiscartUpdateCalculate)
				//  console.log("dadsa culupu primero 3", this.lotReception.AcceptedToleranceInputDiscart)
				//  console.log("dadsa culupu primero 4", this.lotReception.DisFavKgDiscartUpdatePercentage)
				//  console.log("dadsa culupu primero result", this.lotReception.tolWeiDisSelToleranceAcceptedCalculate)

				//este cambie
				 this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = ( (this.lotReception.RcfWeightGuide - this.lotReception.RfsWeightDevolution)
				 * (this.AcceptedToleranceInputDiscart / 100)).toFixed(6);
				//este
				 this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = parseFloat(this.lotReception.DisFavKgDiscartUpdatePercentage - this.AcceptedToleranceInputDiscart).toFixed(6);
				//  console.log("dadsa culupu primero", this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage)
				 //cambiar porcentaje
				// this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = ((this.lotReception.RcfWeightGuide 
				// 		* parseFloat(this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage)) / 100).toFixed(6);
				this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate  = this.lotReception.DisFavKgDiscartUpdateCalculate - 
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculate;



				// this.lotReception.tolWeiDisSelToleranceAcceptedCalculate = (this.lotReception.WbbNetWeight * (this.AcceptedToleranceInputDiscart / 100)).toFixed(2);
				// this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage = (this.lotReception.DisFavKgDiscartUpdatePercentage - this.AcceptedToleranceInputDiscart).toFixed(2);
				// this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate = ((this.lotReception.WbbNetWeight * this.lotReception.tolWeiDisSelDiferenceNoAcceptedPercentage) / 100).toFixed(2);
				
				// this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.lotReception.DisFavKgDiscartUpdatePercentage;//SAMIR
				this.lotReception.tolWeiDisSelToleranceAcceptedCalculatePR = this.AcceptedToleranceInputDiscart;//SAMIR
				// console.log("dadsa", this.lotReception.RcfWeightGuide)
			}
//ultimo

			
			//case4
			this.lotReception.DisFavKgDiscartUpdatePercentage = Math.abs(this.lotReception.DisFavKgDiscartUpdatePercentage);
			this.lotReception.DisFavKgDiscartUpdateCalculate = Math.abs(this.lotReception.DisFavKgDiscartUpdateCalculate)

			// console.log("dadsa culupu", this.lotReception.DisFavKgDiscartUpdatePercentage)
			this.lotReception.infSelWeightUpdate = (this.lotReception.RcfWeightGuide).toFixed(2);
			this.lotReception.infSelWeightWash = (this.lotReception.WbbNetWeight - this.lotReception.discart - this.lotReception.RfsWeightDevolution - this.lotReception.RfsWeightBolillo).toFixed(2);
			this.lotReception.infSelDiscartFavor = (this.lotReception.infRefDifference - this.lotReception.discart).toFixed(2);

			this.lotReception.infSelDiscartFavor = Math.abs(this.lotReception.infSelDiscartFavor);

			this.lotReception.afavKgafavorPercentage = ((this.lotReception.infSelDiscartFavor / this.lotReception.WbbNetWeight) * 100).toFixed(2);
			if (parseFloat(this.lotReception.afavKgafavorPercentage) < this.afavKgafavorPercentageInput) {

				// console.log("sa 1")
				this.lotReception.afavKgafavorCalculate = ((this.lotReception.afavKgafavorPercentage * this.lotReception.RcfWeightGuide)/100).toFixed(2)//0910WbbNetWeight

			}else{
				this.lotReception.afavKgafavorCalculate = ((this.lotReception.afavKgafavorPercentageInput * this.lotReception.RcfWeightGuide)/100).toFixed(2)//0910WbbNetWeight
				// console.log("sa 2", this.lotReception.afavKgafavorCalculate)
//DisFavKgDiscartUpdatePercentage
			}

			this.lotReception.afavKgafavorPercentageInput = this.afavKgafavorPercentageInput;
			 
			this.lotReception.RfsWeightDiscart = parseFloat(0).toFixed(2);
			this.lotReception.RfsWeigthNotSap = parseFloat(this.lotReception.tolWeiDisSelDiferenceNoAcceptedCalculate).toFixed(2);
			// this.lotReception.RfsWeightDiscart = (parseFloat(this.lotReception.tolWeiDisSelToleranceAcceptedCalculate) + parseFloat(this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate)).toFixed(4);
			// this.lotReception.RfsWeigth = (parseFloat(this.lotReception.DisTotWeightPay) - parseFloat(this.lotReception.RfsWeightDiscart)).toFixed(4);
			// this.lotReception.RfsWeigth = (parseFloat(this.lotReception.infSelWeightWash)).toFixed(4);//infSelWeightUpdate


			//DISTRIBUCIONES DE ALMACENES
			this.lotReception.RfsWeigth = (parseFloat(this.lotReception.infSelWeightUpdate) + parseFloat(this.lotReception.tolWeiDisSelToleranceAcceptedCalculate) - parseFloat(this.lotReception.RfsWeightDevolution)
			- parseFloat(this.lotReception.RfsWeightBolillo)).toFixed(2);//infSelWeightUpdate
			// this.lotReception.RfsWeigthNotSap = (this.lotReception.infSelWeightWash - this.lotReception.RfsWeigth).toFixed(4);
			this.lotReception.DisTotWeightPay = this.lotReception.RfsWeigth + this.lotReception.RfsWeightDiscart;
			 console.log("bolillo33333");
			this.lotReception.RfsWeightExceed = 0
			//if(this.lotReception.RfsWeightBolilloc == 0){
				this.lotReception.RfsWeightBolilloc = this.lotReception.RfsWeightBolillo;
			//}
			//reseteo si es que es 0
			if(this.lotReception.RfsWeigth < 0){
				console.log("this.lotReception.RfsWeigth",this.lotReception.RfsWeigth)
				this.lotReception.RfsWeightExceed = this.lotReception.RfsWeigth * -1;
				// this.lotReception.RfsWeigth = 0;
			
				this.lotReception.RfsWeightExceed = parseFloat(this.lotReception.infSelWeightWash) + 
				parseFloat(this.lotReception.RfsWeightExceed);

				// console.log("this.lotReception.RfsWeightExceed", this.lotReception.RfsWeightExceed);
				 
				this.lotReception.RfsWeigth = this.lotReception.infSelWeightWash;

				this.lotReception.RfsWeightBolilloc -= parseFloat(this.lotReception.RfsWeightExceed);
				// console.log("this.lotReception.RfsWeigthNotSap", this.lotReception.RfsWeigthNotSap)
				// console.log("this.lotReception.RfsWeightExceed", this.lotReception.RfsWeightExceed)
				console.log("RfsWeightBolilloc",this.lotReception.RfsWeightBolilloc);
				this.lotReception.RfsWeigthNotSap = //parseFloat(this.lotReception.RfsWeightExceed) + 
				parseFloat(this.lotReception.RfsWeigthNotSap);

			}
			//VALIDAR SI ES PAGOS DIRECTOS
			let amountProc = this.lotReception.RfsWeigth;
			let amountDisc = this.lotReception.RfsWeightDiscart;

			if (this.lotReception.TypeEntryMerchandise == 3) {
				this.lotReception.RfsWeigth = amountDisc;
			 	this.lotReception.RfsWeightDiscart = amountProc;
			}

			this.lotReception.AcceptedToleranceInput = this.AcceptedToleranceInput;
			this.lotReception.AcceptedToleranceInputDiscart = this.AcceptedToleranceInputDiscart;
			

			this.lotReception.TotalSap = parseFloat(this.lotReception.RfsWeigth) + parseFloat(this.lotReception.RfsWeightDiscart) + parseFloat(this.lotReception.RfsWeightBolilloc)+ parseFloat(this.lotReception.RfsWeightBolilloMaq) + parseFloat(this.lotReception.RfsWeightDiscartMaq) + parseFloat(this.lotReception.RfsWeightDiscardNotAcepptedMaq);
			// console.log("this.lotReception.TotalSap" , this.lotReception.TotalSap)

			this.RfsWeightDiscartLocal = this.lotReception.RfsWeightDiscart;
			this.RfsWeightBolillocLocal = parseFloat(this.lotReception.RfsWeightBolilloc).toFixed(2);
			this.lotReception.PorceBolillo = 0;
			if (this.lotReception.RfsWeightBolillo > 0 && this.lotReception.WbbNetWeight) {
				
				this.lotReception.PorceBolillo = ((parseFloat(this.lotReception.RfsWeightBolillo)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2)
			}
			this.calculateDiscartNotAcepptedMaq();
			this.getCaluleDiscartMaq();
			this.getCaluleBolilloMaq();
		},

		getCaluleBolilloMaq(){

			let valor = this.RfsWeightBolillocLocal;
			let porcentaje = this.AcceptedBolilloMaq;

			this.lotReception.RfsBolilloMaqPercentage = this.AcceptedBolilloMaq;
			this.lotReception.RfsWeightBolilloMaq = (valor * (porcentaje / 100)).toFixed(2);
			console.log("porcentajeBolilloMaq",porcentaje);
			console.log("RfsWeightBolillocLocal",this.RfsWeightBolillocLocal);
			if(this.lotReception.RfsWeightBolilloMaq > 0 && this.lotReception.RfsWeightBolilloMaq != null && this.lotReception.RfsWeightBolilloMaq != undefined){
				this.lotReception.PorceBolilloMaq = ((parseFloat(this.lotReception.RfsWeightBolilloMaq)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2);
				this.lotReception.RfsWeightBolilloc = (parseFloat(this.RfsWeightBolillocLocal) - parseFloat(this.lotReception.RfsWeightBolilloMaq)).toFixed(2) ;				
				this.lotReception.PorceBolillo = ((parseFloat(this.lotReception.RfsWeightBolilloc)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2);
			}
			else{
				this.lotReception.PorceBolilloMaq = 0;
				this.lotReception.RfsWeightBolilloc = this.RfsWeightBolillocLocal;
				this.lotReception.PorceBolillo = ((parseFloat(this.lotReception.RfsWeightBolilloc)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2);
			}
			this.lotReception.TotalSap = parseFloat(this.lotReception.RfsWeigth) + parseFloat(this.lotReception.RfsWeightDiscart) + parseFloat(this.RfsWeightBolillocLocal)+ parseFloat(this.lotReception.RfsWeightDiscartMaq) + parseFloat(this.lotReception.RfsWeightDiscardNotAcepptedMaq);
			console.log("porcentajeBolilloMaq",this.lotReception.PorceBolilloMaq)
			console.log("this.lotReception.RfsWeightBolillo",this.lotReception.RfsWeightBolillo);
			console.log("this.lotReception.RfsWeightDiscartMaq",this.lotReception.RfsWeightDiscartMaq);
		},
		getCaluleDiscartMaq(){
			let valor = 0;
			if((this.RfsWeightDiscartLocal -  this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate) > 0){
				valor = this.RfsWeightDiscartLocal -  this.lotReception.tolWeiNetGuiToleranceAcceptedCalculate;
			}			
			let porcentaje = this.AcceptedDiscartMaq;

			this.lotReception.RfsDiscartMaqPercentage = this.AcceptedDiscartMaq;
			this.lotReception.RfsWeightDiscartMaq = (valor * (porcentaje / 100)).toFixed(2);
			console.log("porcentajeBolilloMaq",porcentaje);
			if(this.lotReception.RfsWeightDiscartMaq > 0 && this.lotReception.RfsWeightDiscartMaq != null && this.lotReception.RfsWeightDiscartMaq != undefined){
				this.lotReception.PorceDiscartMaq = ((parseFloat(this.lotReception.RfsWeightDiscartMaq)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2);
				this.lotReception.RfsWeightDiscart = (this.RfsWeightDiscartLocal - this.lotReception.RfsWeightDiscartMaq).toFixed(2) ;
				//this.lotReception.PorceBolillo = ((parseFloat(this.lotReception.RfsWeightBolilloc)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2);
			}
			else{
				this.lotReception.PorceDiscartMaq = 0;				
				this.lotReception.RfsWeightDiscart = this.RfsWeightDiscartLocal;
				//this.lotReception.PorceBolillo = ((parseFloat(this.lotReception.RfsWeightBolillo)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2);
			}
			this.lotReception.TotalSap = parseFloat(this.lotReception.RfsWeigth) + parseFloat(this.lotReception.RfsWeightDiscart) + parseFloat(this.RfsWeightBolillocLocal)+ parseFloat(this.lotReception.RfsWeightDiscartMaq) + parseFloat(this.lotReception.RfsWeightDiscardNotAcepptedMaq);;
			console.log("porcentajeDiscartMaq",this.lotReception.PorceDiscartMaq);
			console.log("this.lotReception.RfsWeightBolillo",this.lotReception.RfsWeightBolillo);
			console.log("this.lotReception.RfsWeightDiscartMaq",this.lotReception.RfsWeightDiscartMaq);
		}
	},
	computed: {
		// totalKgNoAceptable() {
		// 	// let total = 0;

		// 	// for (const groupKey of Object.keys(this.newGroups)) {
		// 	// 	for (const item of this.newGroups[groupKey]) {
		// 	// 		const totalPct = parseFloat(item.RfcPercentage || 0);
		// 	// 		const noAceptablePct = parseFloat(this.getUnacceptablePercentage(item) || 0);
		// 	// 		const quantity = parseFloat(item.RfcQuantityKg || 0);

		// 	// 		if (totalPct > 0) {
		// 	// 		total += (noAceptablePct * quantity) / totalPct;
		// 	// 		}
		// 	// 	}
		// 	// }

		// 	// return total.toFixed(2);		
		// 	let total = 0;

		// 	for (const groupKey of Object.keys(this.newGroups)) {
		// 	for (const item of this.newGroups[groupKey]) {
		// 		const value = parseFloat(this.getUnacceptableKg(item));
		// 		total += isNaN(value) ? 0 : value;
		// 		console.log("total",total);
		// 	}
		// 	}

		// 	return total.toFixed(2);	
		// }
		finalweightacceptable() {
			const pesoOriginal = this.RfsWeigthLocal || 0;
			const totalKgNoAceptable = this.calculateTotalKgNoAceptable() || 0;
			return (pesoOriginal - totalKgNoAceptable).toFixed(2);
		}
	},
	created() {
		// this.lotReception = this.lotReceptionInput;
 
		this.loadItemsCaliber();
		if(this.lotReception.RfsWeightBolilloMaq > 0){
			this.lotReception.PorceBolilloMaq = ((parseFloat(this.lotReception.RfsWeightBolilloMaq)* 100)/parseFloat(this.lotReception.WbbNetWeight)).toFixed(2);
		}
	},
	mounted() {

		// console.log( { 
		// 	TypeWeight: this.lotReception.TypeWeight, 
		// 	status: "mounted guide",
		// 	AcceptedToleranceInputDiscart : this.AcceptedToleranceInput,
		// 	AcceptedToleranceInput: this.lotReception.AcceptedToleranceInput,
		// 	AcceptedToleranceInputDiscart: this.lotReception.AcceptedToleranceInputDiscart
		//  } )
		 
		// this.AcceptedToleranceInput =  -1;
		// this.AcceptedToleranceInputDiscart = -1;
		// this.AfavKgafavorPercentageInput = -1;
		//  console.log("ads", "das")
		this.AcceptedToleranceInput =  this.lotReception.AcceptedToleranceInput ?? 0;
		this.AcceptedToleranceInputDiscart = this.lotReception.AcceptedToleranceInputDiscart ?? 0;
		this.AfavKgafavorPercentageInput = this.lotReception.AfavKgafavorPercentageInput ?? 0;
		
		this.getCalcule();
		this.RfsWeigthLocal = this.lotReception.RfsWeigth;
		//console.log("Peso Total Aceptable en Local", this.RfsWeigthLocal)

		this.labelCheckBox= this.lotReception.RfsDevolutionByPay ? "Si" : "No";
		this.labelCheckBox2= this.lotReception.RfsDiscardNotAceppted ? "Si" : "No";
		this.AcceptedDiscartMaq = this.lotReception.RfsDiscartMaqPercentage;
		// this.AcceptedDiscartMaq = (this.lotReception.TypeCultive == 3) 
		// 	? ((!this.lotReception.RfsDiscartMaqPercentage || this.lotReception.RfsDiscartMaqPercentage == 0) ? 100 : this.lotReception.RfsDiscartMaqPercentage) 
		// 	: 0;
		this.getCaluleDiscartMaq();
		this.AcceptedBolilloMaq = this.lotReception.RfsBolilloMaqPercentage;		
		console.log("this.lotReception.RfsWeightDiscardNotAcepptedMaq",this.lotReception.RfsWeightDiscardNotAcepptedMaq)
	}
}
</script>
